export default {
  getNotificationState: state => state,
  getNotificationByUserState: state => {
    const { itemsAll } = state;
    itemsAll[1].sort((a, b) => (a.id > b.id ? -1 : a.id < b.id ? 1 : 0));

    itemsAll[2].sort((a, b) => (a.id > b.id ? -1 : a.id < b.id ? 1 : 0));

    return itemsAll;
  }
};
